import './styles.sass';

import React from 'react';

import MentionedIcon from 'icons/chat.svg';
import OutputIcon from 'icons/file.svg';
import MentionsIcon from 'icons/bubbles.svg';

import NumberHelper from 'util/number_helper';
import SaveSearch from 'components/Explorer/SaveSearch';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const Summary = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/summary', params, { reloadOn: ['filters'] });

  if (loading === Loading.ERROR) {
    return (
      <div className="Highlights-Summary">
        <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>
      </div>
    );
  }

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const stat = (value) =>
    isLoading ? <div className="Highlights-loading-message" /> : NumberHelper.formatStatistic(value);

  return (
    <div className="Highlights-Summary">
      <div className="Highlights-content Highlights-Summary-content">
        <div className="stats">
          <div className="stat mentions">
            <div className="icon">
              <MentionsIcon />
            </div>
            <div className="content">
              <div className="title">{I18n.t('Explorer.Highlights.Summary.total_mentions')}</div>
              <div className="count">{stat(data?.mentions)}</div>
            </div>
          </div>
          <div className="stat mentioned_outputs">
            <div className="icon">
              <MentionedIcon />
            </div>
            <div className="content">
              <div className="title">{I18n.t('Explorer.Highlights.Summary.mentioned_outputs')}</div>
              <div className="count">{stat(data?.research_outputs)}</div>
            </div>
          </div>
          <div className="stat total_outputs">
            <div className="icon">
              <OutputIcon />
            </div>
            <div className="content">
              <div className="title">{I18n.t('Explorer.Highlights.Summary.outputs')}</div>
              <div className="count">{stat(data?.total_research_outputs)}</div>
            </div>
          </div>
        </div>
        <div className="tools">
          <SaveSearch endpoint="highlights" analyticsName="Highlights" />
        </div>
      </div>
    </div>
  );
};

export default Summary;
